import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProblemList from '../../components/Problem/ProblemList';
import { fetchAssessment, selectProblem } from '../../store/actions/AssessmentActions';
import { setCurrentPage } from '../../store/actions/commonActions';
import { withRouter } from 'react-router-dom';
import { store } from '../../index';
import { GACategories, GAActions } from '../../analytics';
import { handleGAEvent } from '../../helperFunctions';
import McqCanvas from '../Mcq/McqCanvas';
import ProgressFooter from '../../components/ProgressFooter/ProgressFooter';

// for now it is just a dummy
// all logic is in the Problem Component
// Not removed as now . because it can be used as a wrapper for test with sections.

class AssessmentContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assessment_id: this.props.match.params.id,
      progress: {
        total: 0,
        answered: 0,
        marked: 0,
        skipped: 0,
      },
    };
  }
  setProgress = progress => {
    this.setState({ progress });
  };
  componentDidMount() {
    this.props.setCurrentPage('QSP');
    if (this.props.problems.length === 0) {
      this.props.fetchAssessment(this.state.assessment_id);
    }
  }

  selectProblem = problem => {
    selectProblem(problem)(store.dispatch, store.getState);
  };

  render() {
    return (
      <>
        <McqCanvas
          setProgress={this.setProgress}
          progress={this.state.progress}
        />
        <ProgressFooter progress={this.state.progress} />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    problems: state.assessment.problems,
    assessment_id: state.assessment.id,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selectProblem: problem => dispatch(selectProblem(problem)),
    fetchAssessment: assessment_id => dispatch(fetchAssessment(assessment_id)),
    setCurrentPage: page_identifier => dispatch(setCurrentPage(page_identifier)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AssessmentContainer));
